import { DocumentReference } from '@angular/fire/firestore';
import { firestore } from 'firebase/app';
import { IFirebaseData } from '../interfaces';
import { SerializableModel } from './serializable-model';

export interface IDeliveryMethodData extends IFirebaseData {
  name: string;
  enabled: boolean;
  owner: string | null;
  ownerRef: DocumentReference | null;

  /**
   * Radio / alcance en metros.
   */
  radius: number;
  geolocation?: firestore.GeoPoint;
  defaultPrice: number;
  priceZones?: any;
  polygonArea?: any;
}



/**
 * Propiedades obsoletas.
 *
 * @deprecated use IDeliveryMethodData instead
 */
export interface IOldDeliveryMethodData extends IDeliveryMethodData {
  default_price?: number;
  price_zones?: any;
  polygon_area?: any;
  radio?: number;
  active?: boolean;
}

/**
 * MÃ©todo de pago.
 */
export class DeliveryMethod extends SerializableModel<IDeliveryMethodData> {
  protected static readonly EMPTY: IDeliveryMethodData = {
    name: '',
    enabled: false,
    defaultPrice: 0,
    owner: null,
    ownerRef: null,
    radius: 0,
    geolocation: null,
    priceZones: null,
    polygonArea: null,
  };

  /**
   * Acceso directo a los datos en crudo desde Firebase.
   */
  get data() {
    return this.rawData;
  }

  constructor(
    rawData: IOldDeliveryMethodData | IDeliveryMethodData | DeliveryMethod = DeliveryMethod.EMPTY,
    id?: string
  ) {
    if (rawData instanceof DeliveryMethod) {
      super(rawData.rawData, id);
      return;
    }

    super(rawData, id);

    if (!rawData.owner) {
      this.rawData.owner = null;
    }

    if (!rawData.ownerRef) {
      this.rawData.ownerRef = null;
    }

    this.data.enabled = (rawData.enabled === true) || (rawData.active === true);

    // retro-compatibilidad
    this.rawData.defaultPrice = rawData.defaultPrice || rawData.default_price as number || 0;
    this.rawData.priceZones = rawData.priceZones || rawData.price_zones || null;
    this.rawData.polygonArea = rawData.polygonArea || rawData.polygon_area || null;
    this.rawData.radius = rawData.radius || rawData.radio as number || 0;
  }
}
